module.exports = __webpack_public_path__ + "img/vegetable-okra-350x184.5fafe344.jpg";